/**
 * Contexte de langue FR/LN pour Job Kongo.
 * Usage : const { t, lang, setLang } = useLang();
 */
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { TRANSLATIONS } from './translations';

const LANG_KEY = 'jobkongo_lang';
const LangCtx = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem(LANG_KEY) || 'fr');

  const setLang = useCallback((code) => {
    localStorage.setItem(LANG_KEY, code);
    setLangState(code);
  }, []);

  const t = useCallback((key) => {
    const entry = TRANSLATIONS[key];
    if (!entry) return key;
    return entry[lang] || entry.fr || key;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
